// extracted by mini-css-extract-plugin
export default {"SiteOrange":"#EF7C00","SiteLightGrey":"#B1B1B1","Main":"Spinner_Main__TiwBg","MainPadding":"Spinner_MainPadding__eX6gJ","Orange":"Spinner_Orange__Yqh8O","Gray":"Spinner_Gray__S4lon"};